export class EpsVehicleType {
    vehicle_type_id: number;
    vehicle_short_desc: string;
    vehicle_desc: string;
    vehicle_icon: string;
    vehicle_code: string;

}